import React, { useRef } from 'react';
import { ErrorFlagRenderer } from '@atlassian/jira-error-boundary-flag-renderer';
import { ff } from '@atlassian/jira-feature-flagging';
import { useResource, type RouteResourceError } from '@atlassian/jira-router';
import {
	uifBacklogResource,
	uifBacklogResourceOld,
} from '@atlassian/jira-router-resources-uif-backlog';
import {
	EXPERIENCE_TRACKER_LOCATION_BACKLOG,
	EXPERIENCE_TRACKER_LOCATION_CMP_BACKLOG,
} from '@atlassian/jira-software-backlog/src/common/constants/analytics';
import responseToSla from '@atlassian/jira-software-sla-tracker';
import type { UIFBacklogCachedDataResult } from '@atlassian/jira-software-uif-early-script';
import type { JiraPlanDataRestResponse } from '../../rest/fetch-plan-data/types';

type BacklogSlaTrackerProps = {
	error: RouteResourceError | null;
	location?: string | null;
};

export const BacklogSlaTracker = ({ error, location }: BacklogSlaTrackerProps) => {
	if (error) {
		return (
			<>
				{responseToSla(error, location ?? EXPERIENCE_TRACKER_LOCATION_BACKLOG)}
				{/* eslint-disable-next-line @typescript-eslint/consistent-type-assertions */}
				<ErrorFlagRenderer id={location ?? 'next-gen-backlog'} error={error as Error} />
			</>
		);
	}
	// return null when no errors
	return null;
};

export const CmpBacklogSlaTracker = () => {
	const backlogData = useResource<JiraPlanDataRestResponse | UIFBacklogCachedDataResult | null>(
		ff('jsw.perf.enable-indexeddb-caching-for-backlog')
			? uifBacklogResource
			: uifBacklogResourceOld,
	);

	const hasFired = useRef(false);
	if (
		hasFired.current ||
		!backlogData ||
		!backlogData.error ||
		backlogData.data ||
		backlogData.loading
	) {
		return null;
	}

	hasFired.current = true;
	return (
		<BacklogSlaTracker
			error={backlogData?.error}
			location={EXPERIENCE_TRACKER_LOCATION_CMP_BACKLOG}
		/>
	);
};
